// Import the functions you need from the SDKs you need
// FIX: Switched to Firebase v8 compat API to resolve module export errors.
import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/functions";
import "firebase/compat/storage";
import "firebase/compat/firestore";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBlHWEgbqYBW6DWipD6ImPJiuBYumF6bWA",
  authDomain: "lvmh-editor.firebaseapp.com",
  projectId: "lvmh-editor",
  storageBucket: "lvmh-editor.firebasestorage.app",
  messagingSenderId: "400620783493",
  appId: "1:400620783493:web:4e28dfbed89315cc0be6ec",
  measurementId: "G-ZTP2BHDD7L"
};


// Initialize Firebase
const app = firebase.apps.length > 0
  ? firebase.app()
  : firebase.initializeApp(firebaseConfig);

const shouldInitializeAnalytics = import.meta.env.VITE_ENABLE_FIREBASE_ANALYTICS === "true";

async function initializeAnalyticsSafely(): Promise<void> {
  if (!shouldInitializeAnalytics) {
    return;
  }

  if (typeof window === "undefined") {
    return;
  }

  if (window.crossOriginIsolated) {
    console.info("[Firebase] Skipping Analytics because COEP blocks Google Tag Manager in this context.");
    return;
  }

  try {
    await import("firebase/compat/analytics");
    firebase.analytics();
  } catch (error) {
    console.warn("[Firebase] Analytics disabled:", error);
  }
}

void initializeAnalyticsSafely();

export { app };
export const auth = firebase.auth();
export const functions = firebase.functions();
export const firestore = firebase.firestore();

// Export specific functions for type safety and usage
export const getStreamUploadUrl = firebase.functions().httpsCallable('getStreamUploadUrl');
export const getUploadUrl = firebase.functions().httpsCallable('getUploadUrl');
export const getR2UploadUrl = firebase.functions().httpsCallable('getR2UploadUrl');
export const deleteFirebaseFile = firebase.functions().httpsCallable('deleteFirebaseFile');
export const analyzeVideoWithGemini = firebase.functions().httpsCallable('analyzeVideoWithGemini');
